<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName?.toUpperCase() }}</p>
    </div>
    <osp-table [tblConfig]="fireDistrictTblConfig" (onRowClick)="onRowClick($event)" [selectedRow]="selectedRow"></osp-table>
    <div id="fire-district-maintenance-loading">
        <div class="form-loader"></div>
    </div>
    <div *ngIf="showForm" class="form-content">
        <form [formGroup]="forms.fireDistrictForm" class="form">
            <div id="fire-district-error-message"></div>
            <div class="form-container-grid">
                <div class="field required">
                    <label>District Code</label>
                </div>
                <div class="">
                    <input formControlName="districtCd" maxlength="25" alphanumeric >
                </div>
                <div class="field required">
                    <label>Active</label>
                </div>
                <div class="">
                    <select formControlName="active">
                        <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                            {{activeType.name}}
                        </option>
                    </select>
                </div>
                <div class="field required">
                    <label>Short Description</label>
                </div>
                <div class="">
                    <input formControlName="distShortDesc" maxlength="50" >
                </div>
                <div class="field">
                    <label>State</label>
                </div>
                <div class="">
                    <input formControlName="stateDisp">
                    <button matSuffix class="btn btn-search" type="button" (click)="openLov['state']()" >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <div class="field required">
                    <label>Long Description</label>
                </div>
                <div class="span">
                    <input formControlName="distLongDesc" maxlength="1000" >
                </div>
                <div class="field required">
                    <label>BPIMS Code</label>
                </div>
                <div class="">
                    <input formControlName="bmCode" maxlength="8" alphanumeric >
                </div>
                <div class=""></div>
                <div class=""></div>
                <div class="field">
                    <label>Remarks</label>
                </div>
                <div class="span">
                    <input formControlName="remarks" maxlength="1000" >
                </div>
                <div class="field">
                    <label>Last Update User</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdateUser" >
                </div>
                <div class="field">
                    <label>Last Update</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdate" >
                </div>
            </div>
        </form>
        <div class="btn-grp">
            <button *ngIf="btns.fireDistrict.updateDisabled" class="btn btn2" type="button" (click)="onAdd()" [disabled]="btns.fireDistrict.addDisabled" >ADD</button>
            <button *ngIf="!btns.fireDistrict.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()" >UPDATE</button>
            <button class="btn btn2" type="button" [disabled]='btns.fireDistrict.deleteDisabled' (click)="onDelete()" >DELETE</button>
        </div>
        <div class="mtn-title"></div>
        <div class="btn-grp">
            <button class="btn btn2" type="button" [disabled]='btns.fireDistrict.saveDisabled' (click)="onSave()" >SAVE</button>
        </div>
    </div>
</div>
